/**
 * Platform (Super Admin) auth API — calls /platform/api/v1/auth/* only.
 */

import { platformHttp } from './http';
import type {
  PlatformAuthRequest,
  PlatformAuthResponse,
  PlatformRefreshRequest,
} from './types';

export const platformAuthApi = {
  login(data: PlatformAuthRequest): Promise<PlatformAuthResponse> {
    return platformHttp
      .post<PlatformAuthResponse>('/auth/login', data)
      .then((r) => r.data);
  },

  refresh(data: PlatformRefreshRequest): Promise<PlatformAuthResponse> {
    return platformHttp
      .post<PlatformAuthResponse>('/auth/refresh', data)
      .then((r) => r.data);
  },

  logout(data: PlatformRefreshRequest): Promise<void> {
    return platformHttp.post('/auth/logout', data).then(() => undefined);
  },
};
